import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component({
    name: "RunStatus"
})
export default class RunStatus extends Vue {
    @Prop() readonly item: any;
    @Prop() readonly showErrorHelp: boolean;
    @Prop() readonly showSuccessShare: boolean;
    @Prop() readonly isRunning: boolean;
    @Prop() readonly isDisable: boolean;
    @Prop() readonly isSuccessEmpty: boolean;

    @Emit() handleJumpClick() {}
    @Emit() handleAnswerClick() {}
    @Emit() handleShareClick() {}
}

//@ts-ignore
export { default as RunStatus } from "./index.vue";
